module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic7.170205e3.png";